import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { SaferpayAltStatusResult } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import { PaymentRequestGroupBancontact } from '../../../components/checkout/payment-request/PaymentRequestGroupBancontact';
import { checkoutMutations, checkoutQueries } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@as-react/common-queries';
export const PaymentRequestGroupBancontactContainer = ({ paymentRequestId, totalPrice, group, }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { postInitSaferpayAlternative, postRequestSaferpayToken } = checkoutMutations({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { mutateAsync: postInitSaferpayAlternativeMutation } = useMutation(postInitSaferpayAlternative);
    const { mutateAsync: postRequestSaferpayTokenMutation } = useMutation(postRequestSaferpayToken);
    const { getStatusSaferpayAlternative } = checkoutQueries({
        servicesEndpoint: servicesEndpoint,
        defaultRequestParams: defaultRequestParams,
    });
    const handleSubmit = (saferpayFieldsToken) => __awaiter(void 0, void 0, void 0, function* () {
        if (saferpayFieldsToken) {
            const response = yield postRequestSaferpayTokenMutation({ paymentRequestId, saferpayFieldsToken });
            if (response === null || response === void 0 ? void 0 : response.redirectUrl) {
                location.href = response.redirectUrl;
            }
        }
    });
    const handleInitAlternative = () => {
        return postInitSaferpayAlternativeMutation(paymentRequestId);
    };
    const handlePollingAlternative = (requestId) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield queryClient.fetchQuery(getStatusSaferpayAlternative(requestId, { staleTime: 0 }));
        if ((result === null || result === void 0 ? void 0 : result.status) &&
            (result.status === SaferpayAltStatusResult.CAPTURED || result.status === SaferpayAltStatusResult.FAILURE)) {
            if (result.redirectUrl) {
                return result.redirectUrl;
            }
            return '';
        }
        return '';
    });
    return (_jsx(PaymentRequestGroupBancontact, { selected: true, group: group, totalPrice: totalPrice, onSubmit: handleSubmit, onInitAlternative: handleInitAlternative, onPollingAlternative: handlePollingAlternative }));
};
